import type { ParametrosDelivery } from "../../../services/configuracaoDeliveryFornecedor"

export type ParametrosDeliveryModel = ParametrosDelivery

export const ParametrosDeliveryInicial: ParametrosDeliveryModel = {
    pedidoMinimo: 0,
    minimoEntregaGratis: null,
    valorMinimoRetiradaNoLocal: null,
    valorMaximoRetiradaNoLocal: null,
    valorMaximoPagamentoOnline: null,
    tempoRetiradaLocal: null,
    delivery: 1,
    tempoEntregaTexto: null,
    entregaGratis: false,
    considerarTaxaEntregaPedidoMinimo: true,
    permiteRetiradaBalcao: false,
    permiteFormaPagamentoMesa: false,
}
